import { SubtleLoader } from '@/ui'
import type { WhatsAppConversationData } from '@jobilla/nexus-sdk'
import { MessageCircleIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { ConversationRow } from './conversation-row'

export type ConversationListProps = {
	conversations: WhatsAppConversationData[]
	isLoading: boolean
	selectedCandidateId: string | null
	onSelect: (conversation: WhatsAppConversationData) => void
}

export function ConversationList({ conversations, isLoading, selectedCandidateId, onSelect }: ConversationListProps) {
	const { t } = useTranslation('common')

	if (isLoading) {
		return (
			<div className="flex justify-center py-12">
				<SubtleLoader delay={0} />
			</div>
		)
	}

	if (conversations.length === 0) {
		return (
			<div className="flex flex-col items-center justify-center py-16 text-grey-400">
				<MessageCircleIcon className="mb-3 size-10 opacity-50" />
				<p className="text-sm">{t('whatsappInbox.empty')}</p>
			</div>
		)
	}

	return (
		<div>
			{conversations.map((conversation) => (
				<ConversationRow
					key={`${conversation.candidateId}-${conversation.campaignId ?? 'none'}`}
					conversation={conversation}
					isSelected={selectedCandidateId === conversation.candidateId}
					onSelect={onSelect}
				/>
			))}
		</div>
	)
}
